import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { Switch, Route, useLocation } from 'react-router-dom';

// Custom Hook
import useFetch from './hooks/useFetch';
import useEffectSkipInitialRender from './hooks/useEffectSkipInitialRender';

// Components
import Header from './components/Header/Header';
import SplashScreen from './components/SplashScreen/SplashScreen';

// Pages
import Home from './pages/Home/Home';
import Content from './pages/Content/Content';
import Weather from './pages/Weather/Weather';
import Video from './pages/Video/Video';
import Tour from './pages/Tour/Tour';
import TourDetail from './pages/Tour/TourDetail';

const App = () => {
  let { pathname } = useLocation();
  const { data, refetch } = useFetch();

  useEffectSkipInitialRender(() => {
    if (pathname === '/') {
      refetch();
    }
  }, [pathname]);

  return (
    <>
      {data === null ? (
        <SplashScreen />
      ) : (
        <>
          <Header />
          <AnimatePresence>
            <Switch>
              <Route exact path='/' component={() => <Home data={data} />} />
              <Route
                path='/rundgang-hausboote/:name'
                component={() => <TourDetail />}
              />

              {data.sections.main.map((article) => {
                const cssClass = article.cssID[1];

                switch (cssClass) {
                  case 'video':
                    return (
                      <Route
                        key={article.alias}
                        path={`/${article.alias}`}
                        component={(props) => (
                          <Video {...props} content={article.content} />
                        )}
                      />
                    );
                  case 'weather':
                    return (
                      <Route
                        key={article.alias}
                        path={`/${article.alias}`}
                        component={(props) => (
                          <Weather
                            {...props}
                            title={article.title}
                            content={article.content}
                          />
                        )}
                      />
                    );
                  case 'tour':
                    return (
                      <Route
                        exact
                        key={article.alias}
                        path={`/${article.alias}`}
                        component={(props) => (
                          <Tour
                            {...props}
                            title={article.title}
                            content={article.content}
                          />
                        )}
                      />
                    );
                  default:
                    return (
                      <Route
                        key={article.alias}
                        path={`/${article.alias}`}
                        component={(props) => (
                          <Content
                            {...props}
                            title={article.title}
                            teaser={article.teaser}
                            content={article.content}
                            icon={article.alias}
                          />
                        )}
                      />
                    );
                }
              })}
            </Switch>
          </AnimatePresence>
        </>
      )}
    </>
  );
};

export default App;
